import styles from "./index.module.scss"
import eventBus from "@utils/eventBus";
import InviteUserModal from '@view/compoents/inviteUserModal/inviteUserModal'
import { useContext } from "react";
import { AppContext } from '@utils/AppContext';
import Utils from '@utils/utils';
import { HOME_PAGE_TYPE } from "@utils/CONST"
import { useNavigate } from "react-router";
import Iconfont from '@utils/Iconfont';

function MembershipBtn (props) {
    return <>
        <div className={styles.MembershipBtn} onClick={props.onClick}>
            <Iconfont type="icon-CrownFilled" />
            <span>会员低至0.17元/图</span>
        </div>
    </>
}

function NewUserBtn (props) {
    const navigate = useNavigate();

    const handleClick = () => {
        eventBus.emit('login', {
            callback: logged => {
                if (logged) {
                    Utils.useroplog(HOME_PAGE_TYPE.CLOTHING, 'function', 'navigation', { from: 'home' })
                    Utils.clearAllTaskCache()
                    navigate("/home/homemain/clothes")
                }
                else console.log('取消了登录')
            }
        })
    }

    return <>
        <div className={styles.NewUserBtn} onClick={handleClick}>
            <Iconfont type="icon-GiftFilled" />
            <span>新人免费作图60张</span>
        </div>
    </>
}

function InviteBtn (props) {
    const { globalUser } = useContext(AppContext);

    return <>
        <div className={styles.InviteBtn} onClick={() => eventBus.emit('inviteUser')}>
            <Iconfont type="icon-GiftFilled" />
            <span>邀请有礼</span>
        </div>
        <InviteUserModal invitationCode={globalUser?.invitationCode} />
    </>
}

function ServiceBtn (props) {
    const navigate = useNavigate();
    const handleClick = () => {
        navigate("/service")
    }
    return (
        <div className={styles.ServiceBtn} onClick={handleClick}>
            <Iconfont type="icon-FireFilled" />
            <span>AI服务助手</span>
        </div>
    )
}

export {
    MembershipBtn,
    NewUserBtn,
    InviteBtn,
    ServiceBtn
}